import { render, staticRenderFns } from "./reporthealthtip.vue?vue&type=template&id=7050df63&scoped=true&"
import script from "./reporthealthtip.vue?vue&type=script&lang=js&"
export * from "./reporthealthtip.vue?vue&type=script&lang=js&"
import style0 from "./reporthealthtip.vue?vue&type=style&index=0&id=7050df63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7050df63",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7050df63')) {
      api.createRecord('7050df63', component.options)
    } else {
      api.reload('7050df63', component.options)
    }
    module.hot.accept("./reporthealthtip.vue?vue&type=template&id=7050df63&scoped=true&", function () {
      api.rerender('7050df63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/physical/reporthealthtip.vue"
export default component.exports